import { Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { fetchData } from '@/components/util';
import GalleryDrawer from './GalleryDrawer';
import GalleryThumbnails from './GalleryThumbnails';

type Props = {
  tour: any;
};

export default function Gallery({ tour }: Props) {
  const [open, setOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (tour?.id) {
      fetchData('public/getAllTourImages', 'POST', {
        id: tour.id,
      })
        .then((data) => {
          if (!data.images) {
            toast.error("Couldn't load images");
          } else {
            const imgs = data.images.map((img: any) => `${process.env.REACT_APP_AWS}/tours/${tour.id}/images/${img.url}`);
            setImages(imgs);
          }
        })
        .catch((err) => {
          console.error(err.message);
        });
    }
  }, [tour?.id]);

  const handleThumbnailClick = (i: number) => {
    setOpen(true);
    setIndex(i);
  };

  return (
    <Stack id="gallery">
      <Typography variant="h5">{tour?.translation?.gallery || 'Gallery'}</Typography>
      <GalleryThumbnails gallery={images} tour={tour} onClick={handleThumbnailClick} />
      <GalleryDrawer images={images} tour={tour} open={open} onClose={() => setOpen(false)} index={index} />
    </Stack>
  );
}
